import { useState, useEffect } from 'react';
import { activityRegistrationService } from '../apiService';

/**
 * Hook personnalisé pour gérer les activités
 */
export const useActivities = () => {
  const [activities, setActivities] = useState([]);
  const [selectedActivity, setSelectedActivity] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  /**
   * Récupère les activités depuis l'API
   */
  const fetchActivities = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const data = await activityRegistrationService.fetchActivities();
      setActivities(data);
    } catch (error) {
      console.error('Erreur lors de la récupération des activités:', error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  /**
   * Retry en cas d'erreur
   */
  const retryFetch = () => {
    fetchActivities();
  };

  /**
   * Réinitialise la sélection d'activité
   */
  const resetSelection = () => {
    setSelectedActivity('');
  };

  /**
   * Obtient l'activité sélectionnée
   * @returns {Object|null} L'activité sélectionnée ou null
   */
  const getSelectedActivity = () => {
    return activities.find(activity => activity.id.toString() === selectedActivity) || null;
  };

  /**
   * Change l'activité sélectionnée
   * @param {string} activityId - L'ID de l'activité à sélectionner
   */
  const selectActivity = (activityId) => {
    setSelectedActivity(activityId);
  };

  // Récupération des activités au chargement
  useEffect(() => {
    fetchActivities();
  }, []);

  return {
    // États
    activities,
    selectedActivity,
    loading,
    error,
    
    // Actions
    fetchActivities,
    retryFetch,
    resetSelection,
    selectActivity,
    
    // Utilitaires
    getSelectedActivity
  };
};